module.exports = __webpack_public_path__ + "img/play.1dfef2a8.png";